export const HEADERS = [
  'HEADER.ID',
  'HEADER.NAME',
  'HEADER.INDUSTRY.NAME',
  'HEADER.SLUG',
  'HEADER.CREATED',
];
